import { TillDatasource, TillDatasourceConfig } from './till/TillDatasource';

export * from './till';

const tillDatasourceConfig: TillDatasourceConfig = {
  baseURL: process.env.REACT_APP_API_SERVER_URL ?? ''
};
export const tillDatasource = new TillDatasource(tillDatasourceConfig);
